import { Platform } from '@angular/cdk/platform';
import {
  ChangeDetectionStrategy,
  Component,
  DOCUMENT,
  inject,
  Renderer2,
  ViewEncapsulation,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'customer-portal-layout',
  templateUrl: './layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [RouterOutlet],
})
export class CustomerPortalLayoutComponent {
  constructor() {
    const platform = inject(Platform);
    const _document = inject(DOCUMENT);
    const renderer = inject(Renderer2);

    if (platform.ANDROID || platform.IOS) {
      renderer.addClass(_document.body, 'is-mobile');
    }
  }
}
